
define('text!pages/help/help_page_template.html',[],function () { return '<div class="help-page">\r\n  <div class="page-title panel">\r\n    <p><%- _.t(\'page_titles.help\') %></p>\r\n  </div>\r\n\r\n  <div class="help-video"></div>\r\n\r\n  <div class="help-page-content panel"></div>\r\n</div>\r\n';});

